module.exports = __webpack_public_path__ + "img/ethereum-logo.2ae36d7c.png";